import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminModuleComponent} from './admin-module.component';
import {AdminAuthorizedGuard} from "./guards/admin-authorized.guard";
import {UserListViewComponent} from "./views/user-list-view/user-list-view.component";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import {CRMModule} from "../crm/crm.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {UserListComponent} from './components/user-list/user-list.component';
import {EStoreMigrationViewComponent} from './views/e-store-migration-view/e-store-migration-view.component';
import {AutoCompleteModule} from "primeng/primeng";
import {OrganizationModule} from "../organization/organization.module";
import {EStoreMigrationGuard} from "./guards/estore-migration.guard";
import {StoreManagementModule} from "../store-management/store-management.module";

@NgModule({
  imports: [
    CommonModule, RouterModule, FormsModule, ReactiveFormsModule,
    AutoCompleteModule,
    VisbosCoreModule, CRMModule, OrganizationModule, StoreManagementModule
  ],
  providers: [AdminAuthorizedGuard, EStoreMigrationGuard],
  declarations: [AdminModuleComponent, UserListViewComponent, UserListComponent, EStoreMigrationViewComponent]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts